module.exports = __webpack_public_path__ + "img/qa.78909a6f.svg";